<ui-modal size="lg" [modalTitle]="modalTitle" [scrollable]="true">
	<div style="top: -1.5rem;" class="d-flex sticky-top bg-white align-items-center pt-2 pb-4 justify-content-between">
		<h1 class="mb-0">All Addresses</h1>
		<div class="d-flex align-items-center">
			<button *ngIf="canCollapseAll() && viewMode === 'grid'" class="btn btn-outline-secondary border-0 ml-1"
				(click)="collapseAll()">Collapse All</button>
			<button *ngIf="viewMode === 'grid'" class="btn btn-outline-secondary border-0 ml-1 mr-2"
				(click)="expandAll()">Expand All</button>
			<div class="input-group w-14r">
				<div class="input-group-prepend">
					<span class="input-group-text"><i class="wq wq-search"></i></span>
				</div>
				<input type="search" class="form-control" placeholder="Search addresses"
					(ngModelChange)="onSearchChange($event)" [(ngModel)]="search" autocomplete="chrome-off"
					spellcheck="false" />
			</div>
			<div class="w-12r ml-2 mr-2" *ngIf="typesList.length">
				<ui-checkbox-dropdown dropdownName="Type" [items]="typesList" [selectedItems]="typeFilter"
					[selectProp]="'id'" [labelProp]="'label'" (selectionChange)="onTypesChange($event)">
				</ui-checkbox-dropdown>
			</div>
			<div class="btn-group ml-2" role="group" aria-label="View toggle">
				<a class="btn"
					[ngClass]="{ 'btn-outline-secondary': viewMode!=='list', 'btn-primary': viewMode==='list' }"
					ngbTooltip="List View" (click)="viewMode='list';">
					<i class="wq wq-list"></i>
				</a>
				<a class="btn"
					[ngClass]="{ 'btn-outline-secondary': viewMode!=='grid', 'btn-primary': viewMode==='grid' }"
					ngbTooltip="Grid View" (click)="viewMode='grid'">
					<i class="wq wq-grid"></i>
				</a>
			</div>
		</div>
	</div>

	<div *ngIf="loading" class="py-5 text-center">
		<ui-wait></ui-wait>
	</div>

	<div *ngIf="!loading && viewMode==='list'">
		<div *ngIf="allFilteredAddresses.length; else noListRows">
			<table class="table table-hover mb-4">
				<thead>
					<tr>
						<th>Address</th>
						<th class="text-right">Address Type</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of allFilteredAddresses;" (click)="selectAddress(item)"
						[ngClass]="{'table-primary': isSelected(item)}" class="selectable mt-2">
						<td class="p-2" (click)="selectAddress(item)">
							<div class="text-medium text-bold text-lines lines-1" uiEllipsisTooltip>
								{{ item.description || item.name || item.title || '—' }}
							</div>
							<div *ngIf="item.is_default" class="badge badge-success mt-1">Default</div>
							<div class="text-small text-muted text-lines lines-1 mt-1" uiEllipsisTooltip>
								{{ app.getAddressSingleLine(item) }}
							</div>
						</td>
						<td class="text-right p-2" (click)="selectAddress(item)">
							<div class="badge" [ngClass]="'badge-' + (item?.badge?.bgColor)">
								<i class="mr-1" [class]="item?.badge?.icon || 'wq wq-location'"></i>
								{{ item?.badge?.label }}
							</div>
						</td>
					</tr>

				</tbody>
			</table>
		</div>
		<ng-template #noListRows>
			<p class="text-muted mb-0">No addresses match your search.</p>
		</ng-template>
	</div>

	<div *ngIf="!loading && viewMode==='grid'">
		<ng-container *ngFor="let g of addressGroups">
			<div class="bg-light p-2 selectable d-flex align-items-center mt-1" (click)="toggle(g.type)">
				<i class="wq mr-2"
					[ngClass]="{ 'wq-chevron-right': !expanded[g.type], 'wq-chevron-down': expanded[g.type] }"></i>
				<div class="text-bold">{{ g.label }}</div>
				<div class="ml-2">({{ filtered(g.items, g.type).length }})</div>
			</div>

			<div *ngIf="expanded[g.type]" class="pl-4 pr-4 pt-3 pb-2">
				<ng-container *ngIf="filtered(g.items, g.type) as items">
					<div class="addr-grid" *ngIf="items.length; else noGroupAddresses">
						<div *ngFor="let a of items" (click)="selectAddress(a)"
							class="hoverable selectable p-2 rounded border d-flex flex-column justify-content-between"
							[ngClass]="{'addr-selected border-primary': isSelected(a)}">
							<div>
								<div class="d-flex justify-content-between">
									<div class="text-bold text-medium text-lines lines-1 mb-2" uiEllipsisTooltip>
										{{ a.description || a.name || a.title || '—' }}
									</div>
									<div *ngIf="a.is_default" class="badge badge-success h-50">Default</div>
								</div>
								<div *ngIf="a.address_line_1" class="text-small text-lines lines-1" uiEllipsisTooltip>
									{{ a.address_line_1 }}
								</div>
								<div *ngIf="a.posttown" class="text-small text-lines lines-1" uiEllipsisTooltip>
									{{ a.posttown }}
								</div>
								<div *ngIf="a.postcode" class="text-small text-lines lines-1" uiEllipsisTooltip>
									{{ a.postcode }}
								</div>
								<div *ngIf="a.county" class="text-small text-lines lines-1" uiEllipsisTooltip>
									{{ a.county }}
								</div>
								<div *ngIf="a.state" class="text-small text-lines lines-1" uiEllipsisTooltip>
									{{ a.state }}
								</div>
								<div *ngIf="a.country" class="text-small text-lines lines-1" uiEllipsisTooltip>
									{{ a.country }}
								</div>
							</div>
							<div class="text-right mt-2 align-self-end"
								[ngClass]="'badge badge-' + (g.bgColor || 'secondary')">
								<i class="text-large mr-2" [class]="g.icon || 'wq wq-location'"></i>
								{{ formatGroupLabel(g?.label) }}
							</div>
						</div>
					</div>

					<ng-template #noGroupAddresses>
						<p class="text-muted mb-0">No addresses found in this group.</p>
					</ng-template>
				</ng-container>
			</div>

		</ng-container>
		<p *ngIf="!addressGroups.length" class=" mt-3">No addresses found.</p>
	</div>
</ui-modal>